import { render, staticRenderFns } from "./index_buJia.vue?vue&type=template&id=5a5f2019&scoped=true&"
import script from "./index_buJia.vue?vue&type=script&lang=js&"
export * from "./index_buJia.vue?vue&type=script&lang=js&"
import style0 from "./index_buJia.vue?vue&type=style&index=0&id=5a5f2019&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f2019",
  null
  
)

export default component.exports